import { Component, Inject, Input, OnChanges, OnDestroy, OnInit, PLATFORM_ID, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Comment } from 'src/app/core/models/comment';
import { CommentService } from 'src/app/core/services/comment.service';
import { User } from 'src/app/core/models/user';
import { take, takeUntil } from 'rxjs/operators';
import { DatePipe, isPlatformBrowser } from '@angular/common';
import { UserService } from 'src/app/core/services/user.service';
import { SortData } from 'src/app/core/models/sort-data';
import { Page } from 'src/app/core/models/page';
import { CommentLike } from 'src/app/core/models/comment-like';
import { WrapperResponse } from 'src/app/core/models/wrapper-response';
import { faThumbsUp,faThumbsDown,faComment } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs/internal/Subject';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-comment',
  encapsulation:ViewEncapsulation.None,
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss']
})
export class CommentComponent implements OnInit,OnDestroy,OnChanges {
  @Input('commentCount') commentCount: number;
  @Input('title') title: string;
  @Input('rootId') rootId: string;
  faCmnt=faComment;
  faThmbsU=faThumbsUp;
  faThmbsD=faThumbsDown;
  commentForm: FormGroup;
  submittedComment = false;
  comment: Comment = new Comment();
  comments: Comment[] = [];
  user=new User()
  pageInfo = new Page();
  pageInfoIn = new Page();
  pipe=new DatePipe('tr-TR');
  commentCommentForm: FormGroup;
  submittedCommentComment = false;
  commentComment: Comment = new Comment();
  selectedComment: Comment = new Comment();
  commentIns: Comment[] = [];
  destroy$: Subject<boolean> =new Subject<boolean>();
  destroy1$: Subject<boolean> =new Subject<boolean>();
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public translate: TranslateService,
    private toastr:ToastrService,
    public ngbModal: NgbModal,
    public commentService: CommentService,
    private deviceService: DeviceDetectorService,
    public userService: UserService

  ) { }

  ngOnChanges(changes: SimpleChanges) {
    this.initMethod();
  }
  ngOnDestroy(): void{
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    this.destroy1$.next(true);
    this.destroy1$.unsubscribe();
  }

  ngOnInit(): void {
    this.initMethod();
  }

  initMethod(){
    this.commentForm = this.createFormGroupComment();
    this.pageInfo.pageNumber = 0;
    this.pageInfo.size = 5;
    this.getComments(); // Her route değişikliğinde yorumları yeniden yükle
  }

  configFingerPrint() {
    if (isPlatformBrowser(this.platformId)) {
      const fingerprint = JSON.stringify(this.deviceService.getDeviceInfo());
      this.configFingerPrint()
      this.user.fingerprintid=fingerprint;
      if(!localStorage?.getItem('halkaarz_userinfo')){
        this.userService.checkFingerPrint(fingerprint).then((r) => {
          if(!r&&localStorage?.getItem('halkaarz_userinfo')==null){
          let user=new User()
          user.fingerprintid=fingerprint;
          this.userService.save(user).pipe(take(1))
          .subscribe({
            next: () => {
              this.commentForm?.reset();
              this.submittedComment=false;
              this.comment = new Comment();
              this.getComments()
            },error: (err: any) => {
              this.toastr.error(this.translate.instant("message.error.general.save"));
              console.log(err);
            }
          })
          }
          })
          .catch((error) => {
            console.log("error: ",error);
          });
        }else{
          this.user=JSON.parse(localStorage?.getItem('halkaarz_userinfo')||null);
          this.getComments()
        }
      }
    }

  onSubmitComment() {
    this.submittedComment = true;
    if (this.commentForm.invalid) {
      return;
    }
    this.setFormToObjectComment();
    this.comment.userId=this.user?.id;
    this.comment.rootId=this.rootId;
    this.comment.lang="tr";
    this.comment.country="tr";
    this.comment.status=true;
    this.comment.createDate=new Date();
    this.commentService
      .save(this.comment)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.commentForm?.reset();
        this.submittedComment=false;
        this.comment = new Comment();
        this.getComments();
        },error: (err: any) => {
          console.log(err);
          this.toastr.error(this.translate.instant("message.error.general.save"));
        }
      })
  }
  getComments() {

    let sortData=new SortData<Comment>();
    let comment = new Comment();
    comment.country="tr";
    comment.lang="tr";
    comment.createDate=new Date();
    comment.rootId=this.rootId;
    comment.status=true;
    comment.userId=this.user.id;
    sortData.filter=comment;
    sortData.sorts.push({ dir: "desc", prop: "createDate" });
    this.pageInfo.pageNumber = 0;
    this.pageInfo.size = 5;
    this.commentService.getPageAbleList(this.pageInfo,sortData).pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (pagedData) => {
        this.pageInfo = pagedData.page;
        this.pageInfo.pageNumber = this.pageInfo.pageNumber-1;
        this.comments = pagedData.data;
      },error: (err: any) => {
        console.log("error: ",err);
      }
    })
  }

  onNextComment() {
  console.log("hata")
  }

  updateUserLike(event: Event,selectedComment:Comment,value) {
    event.stopPropagation();
    debugger
    if(!selectedComment.commentlike){
      selectedComment.commentlike=new CommentLike();
    }
    if(selectedComment.commentlike.like!=value){
      selectedComment.commentlike.like=value;
      selectedComment.commentlike.commentId = selectedComment.id;
      selectedComment.commentlike.userId = this.user.id;
      this.commentService
        .updateLike(selectedComment.commentlike)
        .pipe(take(1))
        .subscribe({
          next: (pagedData) => {
            let cl=pagedData as WrapperResponse<CommentLike>;
          selectedComment.commentlike.id=cl?.t?.id;
          if(value==1){
            selectedComment.likeOn=selectedComment.likeOn+1;
            if(selectedComment.likeOff>0){
              selectedComment.likeOff=selectedComment.likeOff-1;
            }
          }else{
            selectedComment.likeOff=selectedComment.likeOff+1
            if(selectedComment.likeOn>0){
              selectedComment.likeOn=selectedComment.likeOn-1;
            }
          }
          this.toastr.success(this.translate.instant("message.info.save.rating"));
          },error: (err: any) => {
            console.log("error: ",err);
          }
        })
      }
}


onSubmitCommentComment(){
  this.submittedCommentComment = true;
  if (this.commentCommentForm.invalid) {
    return;
  }
  this.commentComment.text = this.commentCommentForm.controls['commentText'].value;
  this.commentComment.commentId=this.selectedComment.id;
  this.commentComment.userId = this.user.id;
  this.commentComment.likeOff=0;
  this.commentComment.likeOn=0;
  this.commentComment.userId=this.user?.id;
  this.commentComment.rootId=this.rootId;
  this.commentComment.lang="tr";
  this.commentComment.country="tr";
  this.commentComment.status=true;
  this.commentComment.createDate=new Date();
  this.commentService
  .save(this.commentComment)
  .pipe(take(1))
  .subscribe({
    next: () => {
      this.commentForm?.reset();
      this.submittedComment=false;
      this.commentComment = new Comment();
      this.getInComments(this.selectedComment.id);
    },error: (err: any) => {
      this.toastr.error(this.translate.instant("message.error.general.save"));
      console.log("error: ",err);
    }
  })

}


openPopupWrapper(template,comment) {
  this.selectedComment=comment;
  this.selectedComment.userId = this.user.id;
  this.pageInfoIn = new Page();
  this.pageInfoIn.pageNumber = 0;
  this.pageInfoIn.size = 5;
  this.commentIns= [];
  this.getInComments(this.selectedComment.id);
  this.ngbModal.open(template, { size: "lg" });
}

openPopupNewComment(event: Event,template,comment) {
  event.stopPropagation();
  this.selectedComment=comment;
  this.selectedComment.userId = this.user.id;
  this.pageInfoIn = new Page();
  this.pageInfoIn.pageNumber = 0;
  this.pageInfoIn.size = 5;
  this.getInComments(this.selectedComment.id);
  this.commentCommentForm=this.createFormGroupComment()
  this.ngbModal.open(template, { size: "lg" });
}


getInComments(commentId) {
  let sortData=new SortData<Comment>();
  let comment = new Comment();
  comment.country="tr";
  comment.lang="tr";
  comment.rootId=this.rootId;
  comment.status=true;
  comment.userId=this.user.id;
  comment.commentId=commentId;
  comment.createDate=new Date();
  sortData.filter=comment;
  let objArray: Array<{ dir: string, prop: string }>;
  sortData.sorts.push({ dir: "desc", prop: "createDate" });

  this.commentService.getPageAbleList(this.pageInfoIn,sortData).pipe(takeUntil(this.destroy1$))
  .subscribe({
    next: (pagedData) => {
      this.pageInfoIn = pagedData.page;
      this.pageInfoIn.pageNumber = this.pageInfoIn.pageNumber-1;
      this.commentIns = pagedData.data;
    },error: (err: any) => {
      console.log("error: ",err);
    }
  })
}
  setFormToObjectComment() {
    this.comment.text = this.commentForm.controls['commentText'].value;
  }
  createFormGroupComment(): FormGroup {
    return new FormGroup({
      commentText: new FormControl('', Validators.required),
    });
  }

  public trackByFnComment(item) {
    if (!item) return null;
    return item.id;
  }
}
